import FilterV2 from './FilterV2';

export default FilterV2;
